import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function Modal({ open, onClose, header, children }) {
  return open ? (
    <div>
      <div
        className="fixed inset-0 z-[1003] bg-black/40"
        onClick={() => onClose()}
        role="presentation"
      />
      <div
        className="fixed top-[2%] right-[20%] left-[20%] z-[1004] mx-auto max-h-[90%] max-w-[1024px] overflow-y-scroll rounded-[20px] bg-white pb-4"
        role="dialog"
      >
        <header className="px-8 pb-2 pt-4">
          <h3 className="flex h-[60px] items-center justify-between border-b-[5px] border-[var(--festy-light-gray)] text-xl font-bold text-[var(--festy-muted-text)]">
            <span>{header}</span>
            <button
              type="button"
              className="m-0 cursor-pointer border-none bg-transparent p-0 text-[inherit] transition-colors hover:text-neutral-600"
              onClick={() => onClose()}
              aria-label="Close modal"
            >
              <FontAwesomeIcon icon={['fas', 'times-circle']} />
            </button>
          </h3>
        </header>
        <div className="px-8 py-4">{children}</div>
      </div>
    </div>
  ) : null;
}
